import { dashboardActionTypes } from '../actionTypes'

let types = dashboardActionTypes

const state = {
    chartTimeRange: '1day',
    chartInterval: '1h',
    refreshInterval: 10000
}

const mutations = {
    [types.CHART_TIME_RANGE]: (state, value) => {
        state.chartTimeRange = value
    },
    [types.CHART_INTERVAL]: (state, value) => {
        state.chartInterval = value
    },
    [types.REFRESH_INTERVAL]: (state, value) => {
        state.refreshInterval = value
    }
}

const actions = {
    [types.CHART_TIME_RANGE]: (context, payload) => {
        context.commit(types.CHART_TIME_RANGE, payload)
    },
    [types.CHART_INTERVAL]: (context, payload) => {
        context.commit(types.CHART_INTERVAL, payload)
    },
    [types.REFRESH_INTERVAL]: (context, payload) => {
        context.commit(types.REFRESH_INTERVAL, payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
